import React, {useState} from 'react'
import TagManagerService from 'services/TagManager'
import StorageService from 'services/StorageService/'
import PubSub from 'services/PubSub/'
import CartAction from 'actions/Cart'
import { useViewportMediaQuery } from 'hooks'
import { actionsType } from 'config/constants';
import style from './style.scss'

const SecondaryCartButtons = (props) => {
    const [actionError, setactionError] = useState('')
    const [disabled, setdisabled] = useState(false)
    
    const disabledOptions = props.disabled
    const orderForm = props.orderForm
    const itemsOrden = orderForm && orderForm.items ? orderForm.items : null
    const isMobile = useViewportMediaQuery(1024)
    const messageQuestion = '¿Estás seguro que deseas vaciar el carro?'

    const addToList = () => {
        PubSub.dispatch(actionsType.DRAWER.ADDTO_LIST_OPEN, { orderItems: window ? window.orderItems : {} });
    }

    const getItems = () => {
        return itemsOrden.map((item) => {
            return {
                id: item.id,
                seller: item.seller,
                quantity: item.quantity,
            }
        })
    }

    const emptyCart = () => {
        if (disabled) {
            setdisabled(true)
        }
        TagManagerService.removeAllItemsCart(orderForm.items, 'Cart Step 1');
        const cartEmpty = CartAction.clearCart().then((orderFrm) => {
            setdisabled(false)

            if (actionError) {
                setactionError(!orderFrm || orderFrm.isOld)
            }
        })

        PubSub.dispatch('cart_productRemove', { promise: cartEmpty })
    }

    const openEmptyCart = () => {
        let pathName = window.location.pathname
        TagManagerService.interaction('Vaciar Carrito', pathName, 'Resumen de compra')
        const oldItems = getItems()

        StorageService.setItem('removed_items', JSON.stringify(oldItems))

        setTimeout(() => {
            PubSub.dispatch('modal_confirmation_open', {
                title: `Vaciar carro`,
                message: messageQuestion,
                cancelBtnText: 'Volver',
                confirmBtnText: 'Vaciar',
                viewHeader: true,
                confirmCallback: () => {
                    setTimeout(() => {
                        emptyCart()
                    }, 0)
                },
            })
        }, 0)
    }

    return (
        <div className={`new-cart-buttons-secondary ${isMobile && 'desktop'}`}>
            <button className="new-link new-link-small cart-button-create-list" onClick={addToList}>
                Guardar como lista
            </button>
            {!(disabledOptions && disabledOptions.empty) && (
                <button className="new-link new-link-small cart-button-clean" onClick={() => openEmptyCart()}>
                    Vaciar carro
                </button>
            )}
        </div>
    )
}

export default SecondaryCartButtons